import { render, staticRenderFns } from "./Integradores.vue?vue&type=template&id=37b0c042&scoped=true"
import script from "./Integradores.vue?vue&type=script&lang=js"
export * from "./Integradores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b0c042",
  null
  
)

export default component.exports